import { useState } from "react";
import emailjs from "@emailjs/browser";
import AvatarGuide from "../others/AvatarGuide";
import "./components/Contact.css";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState("idle"); // idle | sending | success | error

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        if (!form.name || !form.email || !form.message) return;

        setStatus("sending");

        emailjs.send(
            "service_erzordp",       
            "template_fr9q8ub",   
            {
                from_name: form.name,
                from_email: form.email,
                message: form.message + " | name => " + form.name + " | Email=> " +  form.email ,
            },
            "Jwu6KNpgiMR7UmdOQ"        
        )
        .then(() => {
            setStatus("success");
            setForm({ name: "", email: "", message: "" });
            setTimeout(() => setStatus("idle"), 4000);
        })
        .catch(() => {
            setStatus("error");
            setTimeout(() => setStatus("idle"), 4000);
        });
    };

    return (
        <div className="contact-container">

            <AvatarGuide
                message="Let's connect! 🤝"
                animate={false}
            />

            <div className="contact-right">

                <h2 className="contact-title">Contact</h2>

                {/* ── SOCIAL LINKS ── */}
                <div className="social-links">
                    <a
                        href="https://github.com/abhisarjain"
                        target="_blank"
                        rel="noreferrer"
                        className="social-btn"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                        </svg>
                        GitHub
                    </a>
                    <a
                        href="https://www.linkedin.com/in/abhisar-jain-00b020186/"
                        target="_blank"
                        rel="noreferrer"
                        className="social-btn social-btn-linkedin"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                        LinkedIn
                    </a>
                </div>

                <div className="contact-divider" />

                {/* ── FORM ── */}
                <div className="contact-form">

                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">Name</label>
                            <input
                                className="form-input"
                                type="text"
                                name="name"
                                placeholder="Your name"
                                value={form.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                                className="form-input"
                                type="email"
                                name="email"
                                placeholder="your@email.com"
                                value={form.email}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Message</label>
                        <textarea
                            className="form-input form-textarea"
                            name="message"
                            placeholder="What's on your mind?"
                            value={form.message}
                            onChange={handleChange}
                            rows={4}
                        />
                    </div>

                    <button
                        className={`submit-btn ${status}`}
                        onClick={handleSubmit}
                        disabled={status === "sending"}
                    >
                        {status === "idle"    && "Send Message →"}
                        {status === "sending" && "Sending..."}
                        {status === "success" && "✓ Message Sent!"}
                        {status === "error"   && "✗ Failed. Try again"}
                    </button>

                </div>

            </div>
        </div>
    );
}